import { usePathname, useRouter } from 'next/navigation';
import { useLocale } from 'next-intl';
import { useEffect } from 'react';
import { useAppConfigInit } from '@/modules/app-config/hooks/use-app-config-init';
import { useAppContext } from '@/modules/app-context/use-app-context';
import { useCheckIfThereIsUnacceptedAccesses } from '@/modules/shared-document/hooks/use-check-shared-access';
import { useTranslations } from '@power-core/toolkit';

export const useHeaderParams = () => {
	const t = useTranslations();
	const router = useRouter();
	const selectedLanguage = useLocale();
	const { toast, setAppConfig, showToast } = useAppContext();
	const { appConfig, isPending } = useAppConfigInit();
	const { isUnacceptedAccess, setIsUnacceptedAccesses } = useCheckIfThereIsUnacceptedAccesses();
	const pathName = usePathname();

	useEffect(() => {
		if (!appConfig || !appConfig.name || !appConfig.version) return;

		setAppConfig({
			appName: appConfig.name,
			appVersion: appConfig.version,
			termsOfUseUrl: appConfig.termsOfUse?.url,
			privacyPolicyUrl: appConfig.privacyPolicyUrl,
		});
	}, [appConfig?.name, appConfig?.version, appConfig?.termsOfUse?.url, isUnacceptedAccess]);

	return {
		t,
		router,
		pathName,
		selectedLanguage,
		toast,
		isPending,
		appConfig,
		isUnacceptedAccess,
		showToast,
		setIsUnacceptedAccesses,
	};
};
